module.exports = __webpack_public_path__ + "f4c6040aa0ad1788bba02c636f8b448b.woff";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-regular-webfont.woff
// module id = 136
// module chunks = 0